var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_4482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49245 26.1191L0.435547 0.980957L25.0003 1.03147L22.8254 26.1191L12.8107 29.0189L2.49245 26.1191Z",
    fill: "#E34F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8105 26.5916V3.37549L22.9265 3.40917L21.1226 24.1805L12.8105 26.5916Z",
    fill: "#EF652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1448 9.17458L20.4312 6.10596H4.86963L5.7294 15.5139H16.4692L16.048 19.5265L12.6085 20.4536L9.11855 19.4421L8.93312 17.048H5.84747L6.26903 21.9374L12.6083 23.7076L18.9982 21.9374L19.8579 12.3947H8.57891L8.25858 9.17458H20.1448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_4482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5648,
    height: 28.1319,
    fill: "white",
    transform: "translate(0.435547 0.934082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.55bdeaa157d93602a3be0e6c7d924dc3.svg";
export { ForwardRef as ReactComponent };